import React, { useEffect, useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import "./analytics/analytics.css";
import { colorBrandObject } from "../../constants/brandings";

function TabSchema({ tabs, tabKey }) {
  const [value, setValue] = useState(tabs[0].value);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const getActiveTab = tabs.find(d => d.value === newValue)?.getActiveTab;
    if (typeof getActiveTab === 'function') {
      getActiveTab(newValue)
    }
    sessionStorage.setItem(tabKey, newValue);
  };

  useEffect(() => {
    const selectedTab = sessionStorage.getItem(tabKey);
    const getActiveTab = tabs.find(d => d.value === selectedTab)?.getActiveTab;
    if (typeof getActiveTab === 'function') {
      getActiveTab(selectedTab);
    }
    if (selectedTab) {
      // const defaultTab = selectedTab % tabs.length;
      setValue(selectedTab.toString());
    }
  }, []);

  return (
    <div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginRight: "30px",
              width: "fit-content",
            }}
          >
            <TabList onChange={handleChange} aria-label="lab API tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: colorBrandObject?.primaryButtonColor,
                },
              }}
            >
              {tabs.map((tab) => {
                if (!tab.isHidden) {
                  return <Tab
                    className="subHeaderSemiBold tabHeading"
                    sx={{
                      fontSize: "16px !important", fontWeight: 600, color: `${colorBrandObject?.primaryButtonColor} !important`,
                    }}
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                  />
                } else {
                  return <></>
                }
              })}
            </TabList>
          </Box>
          {tabs.map((tab) => (
            <TabPanel key={tab.value} value={tab.value}>
              {tab.content}
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </div>
  );
}

export default TabSchema;
